import {useCallback} from 'react'

import {useMetrikaContext} from '../Context'
import {Hash} from '../types'

export default function useReachGoalCallback<TParams extends object = Hash<string>, G extends string = string>() {
  const context = useMetrikaContext()

  return useCallback(
    (goal: G, params?: TParams) => {
      return context.current.reachGoal<TParams>(goal, params)
    },
    [context],
  )
}
